import {Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, Input} from '@angular/core';
import {NgCircleProgressModule} from 'ng-circle-progress';

@Component({
  selector: 'app-progress-circle',
  standalone: true,
  templateUrl: './progress-circle.component.html',
  imports: [
    NgCircleProgressModule
  ],
  styleUrls: ['./progress-circle.component.scss']
})
export class ProgressCircleComponent implements OnInit {

  @Input() responsive: boolean;
  @Input() radius: number;
  @Input() title: string;
  @Input() percent: number;

  ngOnInit() {}
}
